import { useQuery, UseQueryResult } from "react-query";
import { useSupabase } from "#next/hooks/use-supbase";
import { useSession } from "@supabase/auth-helpers-react";
import { assert } from "#/utils/general";
import { CommandsLeft, commandsLeft } from "#next/lib/commands-left";
import { Logger } from "#/lib/logging";
import { useRealtimeSubscription } from "#next/hooks/with-react-context/use-realtime-subscription/use-realtime-subscription";


export const useUsageLimits = (): UseQueryResult<CommandsLeft> => {
  const session = useSession();
  const supabase = useSupabase();
  const userId = session?.user.id;

  const queryResult = useQuery<CommandsLeft>([ "usage-limits", userId ], async () => {
    assert(!!userId, "User must be logged in to fetch usage limits");

    const result = await commandsLeft({
      userId: userId,
      browserSupabaseClient: supabase
    });

    if (result.error) {
      Logger.error({
        error: result.error,
        message: "Error fetching usage limits"
      });
      throw result.error;
    }

    return result.data;
  }, {
    enabled: !!userId
  });

  useRealtimeSubscription({
    table: "commands",
    onInsert: async ({ new: newCommand }) => {
      if (!!userId && newCommand.user_id === userId) {
        await queryResult.refetch();
      }
    }
  });

  useRealtimeSubscription({
    table: "user_subscriptions",
    onInsert: async ({ new: newUserSubscription }) => {
      if (!!userId && newUserSubscription.user_id === userId) {
        await queryResult.refetch();
      }
    },
    onDelete: async () => {
      await queryResult.refetch();
    }
  });

  return queryResult;
};